import { ChangeDetectorRef, Directive, NgZone } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { COUNTDOWN_TIMER_5_SECONDS, COUNTDOWN_TIMER_DISABLED, CountdownTimerValues } from './model/countdown-timer-values';

@UntilDestroy()
@Directive({
  selector: '[yatCountdownPage]'
})
export class CountdownPageDirective {
  constructor(private ngZone: NgZone, private ref: ChangeDetectorRef) {}

  readonly closeTimerDisabled = COUNTDOWN_TIMER_DISABLED;
  readonly closeTimerValue = COUNTDOWN_TIMER_5_SECONDS;

  countdownSeconds: CountdownTimerValues = this.closeTimerDisabled;

  startCountdown(): void {
    this.ngZone.run(() => {
      this.countdownSeconds = this.closeTimerValue;
      this.ref.detectChanges();
    });
  }
}
